import { UPDATE_MENU } from 'src/constants/ActionTypes';
import { ISideMenuState } from 'src/entity/StateEntity';
import { RouterConfig } from 'src/routers/urlConfig';

const initialState: ISideMenuState = {
  type: UPDATE_MENU,
  pathName: RouterConfig.Urls.default,
};
export const sideLayoutState = (state: ISideMenuState = initialState, action: ISideMenuState): ISideMenuState => {
  switch (action.type) {
    case UPDATE_MENU:
      return Object.assign({}, state, {
        type: action.type,
        pathName: action.pathName,
      })
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/sideLayoutState.ts